import Component from 'vue-class-component'
import BaseComponent from '@/components/base/BaseComponent'
import LogoutButton from '@/components/dashboard/header/logout/Logout.vue'
import {CompanyDetailsResponse, UserDetailsResponse} from '@payroll/optimus-common'
import {StoreNamespace} from '@/globals/StoreNamespaceGlobal'
import {Getter} from 'vuex-class'

@Component({
    components: {
        LogoutButton
    }
})
export default class HeaderComponent extends BaseComponent {

    @Getter('userDetails', StoreNamespace.AUTHENTICATION) userDetails!: UserDetailsResponse
    @Getter('customerDetails', StoreNamespace.AUTHENTICATION) customerDetails!: CompanyDetailsResponse

    private isOpen: boolean = false

    toggleMobileMenu(): void {
        this.$emit('toggleMobileMenu')
    }

    toggle(): void {
        this.isOpen = !this.isOpen
    }
}